export const COLLABORATOR_PERMISSION_KEYS = [
  "overview",
  "timeline",
  "mission",
  "documents",
  "guests",
  "budget",
  "tables",
  "vendors",
  "dietary_restrictions",
];

export const PERMISSION_LABELS = {
  timeline: "Planning",
  mission: "Missions",
  documents: "Documents",
  guests: "Invités",
  tables: "Plan de table",
  vendors: "Prestataires",
  dietary_restrictions: "Restrictions traiteur",
  budget: "Budget & finances",
};

const PERMISSION_ALIASES = {
  overview: ["overview"],
  timeline: ["timeline", "planning"],
  mission: ["mission", "missions", "task", "tasks"],
  documents: ["documents", "document", "docs"],
  guests: ["guests", "guest"],
  budget: ["budget", "finances", "finance"],
  tables: ["tables", "table", "table_plan"],
  vendors: ["vendors", "vendor"],
  dietary_restrictions: ["dietary_restrictions", "dietary", "restrictions"],
};

function normalizePermissionValue(value) {
  if (value && typeof value === "object") {
    return Boolean(value.enabled || value.allowed || value.value || value.read || value.write);
  }
  return Boolean(value);
}

export function createEmptyCollaboratorPermissions() {
  return COLLABORATOR_PERMISSION_KEYS.reduce((accumulator, key) => {
    accumulator[key] = false;
    return accumulator;
  }, {});
}

export function normalizeCollaboratorPermissions(permissions) {
  const values = permissions || {};
  return COLLABORATOR_PERMISSION_KEYS.reduce((accumulator, key) => {
    const aliases = PERMISSION_ALIASES[key] || [key];
    const alias = aliases.find((candidate) => Object.prototype.hasOwnProperty.call(values, candidate));
    accumulator[key] = alias ? normalizePermissionValue(values[alias]) : false;
    return accumulator;
  }, createEmptyCollaboratorPermissions());
}
